import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CONSTANTS, palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import animations from 'src/styles/animations';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.spin), {}, {
  tableContainer: {
    boxShadow: palette.shadows.light,
    '& .MuiAlert-root': {
      backgroundColor: palette.shades[100]
    }
  },
  containerDefault: {
    paddingBottom: "".concat(CONSTANTS.PAGE_BOTTOM_PADDING, "px"),
    flexGrow: '1'
  },
  containerSmall: {
    paddingBottom: '20px'
  },
  checkboxes: {
    marginTop: '24px',
    '& .MuiFormGroup-root': {
      marginTop: '10px',
      '&:last-child': {
        paddingTop: '24px',
        marginTop: '24px',
        borderTop: "1px solid ".concat(palette.shades[400])
      }
    }
  },
  table: {
    '& .MuiTableCell-root': {
      padding: '20px 24px'
    }
  },
  blankCheckbox: {
    '& path': {
      fill: palette.shades[600]
    }
  },
  cellXs: {
    textAlign: 'center',
    position: 'relative'
  },
  cellXl: {
    width: '320px'
  },
  batchBarWrapper: {
    position: 'fixed',
    bottom: '0',
    left: "".concat(CONSTANTS.SIDEBAR_WIDTH, "px"),
    right: '0',
    backgroundColor: palette.shades[100],
    padding: '24px 0',
    boxShadow: '0px -18px 32px 0px #00000026',
    zIndex: '10'
  },
  batchBarContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px 0 24px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      padding: '0 20px 0 48px'
    }
  },
  selectInfo: {
    display: 'flex',
    alignItems: 'center'
  },
  selectCount: {
    display: 'inline-block',
    marginRight: '10px',
    width: '36px',
    minWidth: '36px',
    height: '36px',
    textAlign: 'center',
    borderRadius: '2px',
    backgroundColor: palette.primary.main,
    '& .MuiTypography-root': {
      color: palette.shades[100],
      lineHeight: '36px'
    }
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    marginLeft: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    '& .modal-trigger': {
      marginRight: '10px'
    }
  },
  wrappedTooltip: {
    marginRight: '10px'
  },
  selectedRow: {
    backgroundColor: palette.shades[200]
  },
  batchDeselect: {
    color: palette.primary.main,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  lightText: {
    color: palette.shades[600]
  },
  modalContentLoader: {
    textAlign: 'center',
    padding: '88px 0',
    '& .MuiTypography-root': {
      marginTop: '10px'
    }
  },
  modalContent: {
    padding: '0 40px 38px 40px'
  },
  spinner: {
    '& .MuiSvgIcon-root': {
      display: 'inline-block',
      animation: '$spin 1.3s infinite linear',
      width: '64px',
      height: '64px',
      '& path': {
        fill: palette.primary.main
      }
    }
  },
  activeCheckbox: {
    '& path': {
      fill: palette.primary.main
    }
  }
}));
export default useStyles;